import { render } from "./TrainBusIcon.vue?vue&type=template&id=dea1f7b4"
import script from "./TrainBusIcon.vue?vue&type=script&lang=js"
export * from "./TrainBusIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__